import React from 'react';
import { useQuery } from 'wasp/client/operations';
import { getGlobalConfig } from 'wasp/client/operations';
import { Loader2, Wrench, ShieldAlert, RefreshCw } from 'lucide-react';

export const MaintenancePage: React.FC = () => {
    const { data: config, isLoading } = useQuery(getGlobalConfig);

    if (isLoading) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-background">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
        );
    }

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 px-4 text-slate-100">
            <div className="relative mb-8">
                <div className="absolute -inset-4 rounded-full bg-primary/20 blur-2xl animate-pulse"></div>
                <div className="relative rounded-2xl bg-slate-900/50 p-6 border border-slate-800 shadow-2xl backdrop-blur-sm">
                    <Wrench className="h-16 w-16 text-primary" />
                </div>
            </div>

            <h1 className="mb-4 text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl text-white bg-gradient-to-br from-white to-slate-500 bg-clip-text text-transparent">
                Site Maintenance
            </h1>

            <p className="mb-8 max-w-lg text-center text-lg text-slate-300">
                {config?.maintenanceMessage || "We're currently performing some scheduled maintenance to improve your experience. We'll be back online shortly!"}
            </p>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 max-w-4xl w-full">
                <div className="flex flex-col items-center rounded-xl bg-white/5 p-6 border border-slate-800 backdrop-blur-sm hover:border-slate-700 transition-colors">
                    <ShieldAlert className="h-8 w-8 text-amber-500 mb-3" />
                    <h3 className="font-semibold text-slate-100">Security Updates</h3>
                    <p className="text-sm text-center text-slate-400 mt-1">We are enhancing our security infrastructure.</p>
                </div>

                <div className="flex flex-col items-center rounded-xl bg-white/5 p-6 border border-slate-800 backdrop-blur-sm hover:border-slate-700 transition-colors">
                    <RefreshCw className="h-8 w-8 text-blue-500 mb-3" />
                    <h3 className="font-semibold text-slate-100">System Refactoring</h3>
                    <p className="text-sm text-center text-slate-400 mt-1">Cleaning up and optimizing core application logic.</p>
                </div>

                <div className="flex flex-col items-center rounded-xl bg-white/5 p-6 border border-slate-800 backdrop-blur-sm hover:border-slate-700 transition-colors sm:col-span-2 lg:col-span-1">
                    <Loader2 className="h-8 w-8 text-emerald-500 mb-3 animate-spin-slow" />
                    <h3 className="font-semibold text-slate-100">Performance</h3>
                    <p className="text-sm text-center text-slate-400 mt-1">Boosting response times across all services.</p>
                </div>
            </div>

            <div className="mt-12 text-sm text-slate-500 font-medium">
                &copy; {new Date().getFullYear()} Gedoba. All rights reserved.
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
      `}} />
        </div>
    );
};
